import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean, dropClassificacaoEstrangeira } from 'utils/drops';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import Title from '../Components/Title';

const Estrangeiro = ({ loading, funcionario = {}, onSubmit }) => {
  const defaultValues = {
    rotina: 'PessoalEstrangeiro',
    entidade_id: funcionario?.entidade_id,
    dtchegada: null,
    classtrabestrang: null,
    casadobr: null,
    filhosbr: null,
  };
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    if (funcionario?.Estrangeiro) {
      const merged = Object.keys(defaultValues).reduce((acc, key) => {
        acc[key] = funcionario?.Estrangeiro[key] ?? defaultValues[key];
        return acc;
      }, {});
      reset(merged);
    }
  }, [funcionario, reset]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title title="Informações de Trabalhador Estrangeiro" disableMargin />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputMask
          type="date"
          name="dtchegada"
          control={control}
          label="Data de Chegada ao Brasil"
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Dropdown
          control={control}
          name="classtrabestrang"
          options={dropClassificacaoEstrangeira}
          label="Classificação do Trabalhador Estrangeiro"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="casadobr"
          control={control}
          options={dropBoolean}
          label="Cônjuge no Brasil"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="filhosbr"
          control={control}
          options={dropBoolean}
          label="Filhos no Brasil"
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          color="primary"
          variant="contained"
          loading={loading}
          onClick={handleSubmit(onSubmit)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Estrangeiro;
